<form #createConvenioForm="ngForm">
    <app-custom-modal #modal [title]="'Cadastrar novo convênio'"
        [subtitle]="'Preencha os campos abaixo para criar um novo convênio'" (onCloseClick)="modal.close()"
        (onSaveClick)="save()" [saveLabel]="'Cadastrar  →'" hideCancel [saveDisabled]="createConvenioForm.invalid">
        <mat-tab-group #tabs>
            <mat-tab label="Informações">
                <div class="container mt-4">
                    <div class="mb-4">
                        <label for="cnpj" class="form-label required">CNPJ</label>
                        <input type="text" validateCpfCnpj class="form-control" name="cnpj" maxlength="32"
                            mask="00.000.000/0000-00" [(ngModel)]="convenio.cnpj" #cnpjModel="ngModel" #cnpjEl id="cnpj"
                            required placeholder="Digite aqui" (ngModelChange)="onChangeCnpj($event)" />
                        <abp-validation-summary [control]="cnpjModel" [controlEl]="cnpjEl"></abp-validation-summary>
                    </div>
                    <div class="mb-4">
                        <label for="razaoSocial" class="form-label required">Razão Social</label>
                        <input type="text" class="form-control" name="razaoSocial" maxlength="150"
                            [(ngModel)]="convenio.razaoSocial" placeholder="Digite aqui" #razaoSocialModel="ngModel"
                            #razaoSocialEl id="razaoSocial" required />

                        <abp-validation-summary [control]="razaoSocialModel"
                            [controlEl]="razaoSocialEl"></abp-validation-summary>
                    </div>
                    <div class="mb-4">
                        <label for="nomeFantasia" class="form-label">Nome fantasia</label>
                        <input type="text" class="form-control" name="nomeFantasia" [(ngModel)]="convenio.nomeFantasia"
                            placeholder="Digite aqui" #nomeFantasiaModel="ngModel" #nomeFantasiaEl id="nomeFantasia"
                            maxlength="150" />

                        <abp-validation-summary [control]="nomeFantasiaModel"
                            [controlEl]="nomeFantasiaEl"></abp-validation-summary>
                    </div>
                    <div class="mb-4">
                        <label for="registroAns" class="form-label">Registro ANS</label>
                        <input type="text" class="form-control" name="registroAns" [(ngModel)]="convenio.registroAns"
                            placeholder="Digite aqui" #registroAnsModel="ngModel" #registroAnsEl id="registroAns"
                            maxlength="6" onlyNumbers />

                        <abp-validation-summary [control]="registroAnsModel"
                            [controlEl]="registroAnsEl"></abp-validation-summary>
                    </div>
                    <div class="mb-4">
                        <label for="email" class="form-label required">E-mail</label>
                        <input type="email" email class="form-control" name="email" [(ngModel)]="convenio.email"
                            placeholder="Digite aqui" #emailModel="ngModel" #emailEl id="email" maxlength="150" />

                        <abp-validation-summary [control]="emailModel" [controlEl]="emailEl"></abp-validation-summary>
                    </div>
                    <div class="mb-4">
                        <label for="ddd" class="form-label">DDD</label>
                        <input type="text" class="form-control" name="ddd" [(ngModel)]="convenio.ddd" onlyNumbers
                            maxlength="2" placeholder="Digite aqui" #dddModel="ngModel" #dddEl id="ddd" />

                        <abp-validation-summary [control]="dddModel" [controlEl]="dddEl"></abp-validation-summary>
                    </div>
                    <div class="mb-4">
                        <label for="telefone" class="form-label">Telefone</label>
                        <input type="text" class="form-control" name="telefone" [(ngModel)]="convenio.telefone"
                            mask="0000-0000 || 00000-0000" placeholder="Digite aqui" #telefoneModel="ngModel"
                            #telefoneEl id="telefone" />

                        <abp-validation-summary [control]="telefoneModel"
                            [controlEl]="telefoneEl"></abp-validation-summary>
                    </div>
                    <div class="mb-4">
                        <label for="fax" class="form-label">Fax</label>
                        <input type="text" class="form-control" name="fax" [(ngModel)]="convenio.fax"
                            mask="0000-0000 || 00000-0000" placeholder="Digite aqui" #faxModel="ngModel" #faxEl
                            id="fax" />

                        <abp-validation-summary [control]="faxModel" [controlEl]="faxEl"></abp-validation-summary>
                    </div>
                    <div class="mb-4">
                        <label for="representante" class="form-label required">Representante</label>
                        <input type="text" class="form-control" name="representante"
                            [(ngModel)]="convenio.representante" required maxlength="150" placeholder="Digite aqui"
                            #representanteModel="ngModel" #representanteEl id="representante" />

                        <abp-validation-summary [control]="representanteModel"
                            [controlEl]="representanteEl"></abp-validation-summary>
                    </div>
                    <div class="mb-4">
                        <label for="cargoRepresentante" class="form-label required">Cargo do representante</label>
                        <input type="text" class="form-control" name="cargoRepresentante"
                            [(ngModel)]="convenio.cargoRepresentante" required maxlength="150" placeholder="Digite aqui"
                            #cargoRepresentanteModel="ngModel" #cargoRepresentanteEl id="cargoRepresentante" />

                        <abp-validation-summary [control]="cargoRepresentanteModel"
                            [controlEl]="cargoRepresentanteEl"></abp-validation-summary>
                    </div>
                </div>
            </mat-tab>
            <mat-tab label="Endereço">
                <div class="container mt-4">
                    <endereco-form #formEndereco></endereco-form>
                </div>
            </mat-tab>
        </mat-tab-group>

    </app-custom-modal>
</form>